export default {"src":"/_next/static/media/applepodcast.a9635321.svg","height":35,"width":196,"blurWidth":0,"blurHeight":0};